module.exports = __webpack_public_path__ + "static/nsfc-a4c4cdfaad25d4adb77ab74b590da7f3.jpg";